import React from 'react';
import ReactPaginate from 'react-paginate';
import PaginationStyles from './Pagination.styles';
import { ReactComponent as SvgTriangleLeft } from '@img/icons/chevron-left.svg';
import { ReactComponent as SvgTriangleRight } from '@img/icons/chevron-right.svg';
const Pagination = ({ pageIndex, pageSize, totalCount, onPageChange, }) => {
    return (React.createElement(PaginationStyles.Wrapper, null,
        React.createElement(ReactPaginate, { pageCount: Math.ceil(totalCount / pageSize), pageRangeDisplayed: 3, marginPagesDisplayed: 1, previousLabel: React.createElement(SvgTriangleLeft, null), nextLabel: React.createElement(SvgTriangleRight, null), forcePage: pageIndex - 1, onPageChange: ({ selected }) => {
                onPageChange(selected + 1);
            } })));
};
export default Pagination;
